module.exports = __webpack_public_path__ + "files/5aee29f45b4bc29cc44cf7a7a7dbeccb.png";